if (document.querySelector('body.template-product .media-thumbnails-swiper.swiper')) {
  let lastWidth = window.innerWidth;

  function checkWindowSize() {
    const currentWidth = window.innerWidth;

    if ((lastWidth <= 749 && currentWidth > 749) || (lastWidth > 749 && currentWidth <= 749)) {
      location.reload();
    }

    lastWidth = currentWidth;
  }

  window.addEventListener('resize', checkWindowSize);

  if (window.matchMedia('(min-width: 750px)').matches) {
    var mediaGalleryThumbnailsSwiper = new Swiper('body.template-product .media-thumbnails-swiper.swiper', {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: false,
      centeredSlides: false,
      loop: false,
      slideToClickedSlide: true,
    });
    var mediaGallerySwiper = new Swiper('body.template-product .media-gallery-swiper.swiper', {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 1,
      mousewheel: true,
      speed: 600,
      observeParents: true,
      grabCursor: true,
      loop: false,
      autoHeight: false,
      centeredSlides: false,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1.5,
        thresholdDelta: 30,
      },
      thumbs: {
        swiper: mediaGalleryThumbnailsSwiper,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}
